'use strict'
//a stream that ends immediately.
module.exports = function empty () {
  return function (abort, cb) {
    cb(true)
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/sources/empty.js
// module id = nPFI
// module chunks = 0